import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'hf-list-search-box',
  templateUrl: './list-search-box.component.html',
  styleUrls: ['./list-search-box.component.scss']
})
export class ListSearchBoxComponent {
  @Input() public group: UntypedFormGroup;
  @Input() public controlName: string;
  @Input() public fieldName: string;
  @Input() public placeholder = '';
  @Input() public icon = 'search';
  @Input() public autocomplete?: string;
  @Input() public type = 'text';
}
